// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/destructuring-assignment, init-declarations */
import React from "react"
// @ts-expect-error: Flow to TS migration.
import { connect, Connector } from "react-redux"
import Translate from "../../NitroTranslate/components/NitroTranslate"
import TranslateNode from "../../NitroTranslate/components/NitroTranslateNode"
import type { FetchedCurrencies } from "@kiwicom/nitro/lib/records/Currency"

import convertPrice from "../../services/price/convertPrice"
import { roundISO4217AmountSelector, currenciesSelector } from "../../services/currencies/selectors"
import { formatPrice } from "../../services/currencies/currencies"
import { getCurrency } from "../../services/options/reducer"
import { getLanguageInfo } from "../../services/staticData/index"
import type { LanguageInfo } from "../../records/LanguageInfo"
import { FormattedMessage } from "react-intl"

type OwnProps = {
  maxSize?: number // max size of string in digits,
  maxSizeWithCurrencySymbol?: number // max size of string in digits + currency symbol,
  showCurrencySymbol?: boolean // undefined = auto,
  alreadyConverted?: boolean
  alreadyRounded?: boolean
  className?: string
  currency?: string // when not specified, taken from "global" options,
  tKey?: string // translation key, translation string has to contain __price__ placeholder,
  children: string | number | null | undefined
  freeInsteadOfZero?: boolean
  upperCaseFree?: boolean
  noBreak?: boolean
  formatThousandsAndDecimals?: boolean
}

type Props = OwnProps & {
  optionsCurrency: string
  currencies: FetchedCurrencies
  langInfo: LanguageInfo
  roundAmount: (arg1: number, arg2: string) => number
}

const Price = (props: Props) => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const chil = props.children || "" // Children should not be optional, but the changes should be done in consumere components also
  const {
    currency: curr,
    currencies,
    langInfo,
    freeInsteadOfZero,
    upperCaseFree,
    optionsCurrency,
    formatThousandsAndDecimals,
    roundAmount,
    maxSize,
    maxSizeWithCurrencySymbol,
  } = props
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  let className = props.className || ""

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const currency = curr || optionsCurrency

  const children = typeof chil === "string" ? Number(chil) : chil

  let amountInEur
  let amountInCurrency
  if (props.alreadyConverted) {
    if (props.alreadyRounded) {
      amountInCurrency = children
    } else {
      amountInCurrency = roundAmount(children, currency)
    }
  } else {
    amountInEur = children
    amountInCurrency = convertPrice(amountInEur, currency, currencies)
  }

  if (amountInCurrency === 0 && freeInsteadOfZero) {
    return props.tKey ? (
      <span className={className}>
        <TranslateNode
          t={props.tKey}
          values={{
            price: (
              <FormattedMessage
                id="support.passenger-details.correct-details.common.free"
                defaultMessage="Free"
              />
            ),
          }}
        />
      </span>
    ) : (
      <span className={className}>
        <Translate
          t="support.passenger-details.correct-details.common.free"
          transform={(s) => (upperCaseFree ? s.toUpperCase() : s)}
        />
      </span>
    )
  }

  let output = formatPrice(
    currencies,
    langInfo,
    currency,
    amountInCurrency,
    formatThousandsAndDecimals,
  )

  if (maxSizeWithCurrencySymbol) {
    const roundedPrice = parseInt(amountInCurrency.toFixed(0), 10)
    output = formatPrice(currencies, langInfo, currency, roundedPrice)

    if (output.length > maxSizeWithCurrencySymbol) {
      output = roundedPrice
      if (Math.round(output) !== output) {
        output = output.toFixed(1)
      }
    }
  }

  if (maxSize) {
    const roundedPrice = parseInt(amountInCurrency.toFixed(0), 10)

    output = formatPrice(currencies, langInfo, currency, roundedPrice)
    if (!props.showCurrencySymbol) {
      // If still too long, remove currency symbol
      output = roundedPrice
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      if (`${output}`.length >= maxSize) {
        // If still too long, round to thousands
        output = roundedPrice / 1000
        if (Math.round(output) !== output) {
          output = output.toFixed(1)
        }
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        output = `${output}k`
        // If too big, (just as maxSize or bigger), add class to notify about that
        className += " long spTypo-caption spTypo-bold"
      }
    }
  }
  const outputString = output.toString()
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  className += ` length-${outputString.length}`

  if (props.noBreak) {
    // replace spaces with nbsp
    return props.tKey ? (
      <span className={className}>
        <Translate t={props.tKey} values={{ price: output }} />
      </span>
    ) : (
      <span className={className}>{outputString.replace(/ /g, "\u00a0")}</span>
    )
  }
  return props.tKey ? (
    <span className={className}>
      <Translate t={props.tKey} values={{ price: output }} />
    </span>
  ) : (
    <span className={className}>{output}</span>
  )
}

Price.defaultProps = {
  className: "",
  maxSize: 0,
  alreadyConverted: false,
  alreadyRounded: false,
  freeInsteadOfZero: false,
  upperCaseFree: true,
  noBreak: false,
  formatThousandsAndDecimals: true,
  showCurrencySymbol: false,
  currency: "",
  tKey: "",
}

const connector: Connector<OwnProps, Props> = connect((state) => ({
  optionsCurrency: getCurrency(state),
  currencies: currenciesSelector(state),
  // @ts-expect-error: Flow to TS migration.
  langInfo: getLanguageInfo(state),
  roundAmount: roundISO4217AmountSelector(state),
}))

export default connector(Price)
